import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { hasPermission } from '../../constants/userRoles';

const Sidebar = ({ onNavigate }) => {
  const { userProfile } = useAuth();

  const navItems = [
    {
      name: 'Dashboard',
      path: '/',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      permission: null,
    },
    {
      name: 'Patients',
      path: '/patients',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      permission: 'viewPatients',
    },
    {
      name: 'Cases',
      path: '/cases',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      permission: 'viewCases',
    },
    {
      name: 'Photos',
      path: '/photos',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      permission: 'viewPhotos',
    },
    {
      name: '2D Checks',
      path: '/2d-checks',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      permission: null,
    },
    {
      name: 'Smile Design',
      path: '/photos',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      permission: 'viewPhotos',
      end: false,
    },
  ];

  const secondaryItems = [
    {
      name: 'Reports',
      path: '/reports',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      comingSoon: true,
    },
    {
      name: 'Settings',
      path: '/settings',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      comingSoon: true,
    },
  ];

  const adminItems = [
    {
      name: 'Users',
      path: '/users',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      permission: 'viewUsers',
    },
    {
      name: 'Audit Logs',
      path: '/audit',
      icon: (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      ),
      permission: 'viewAuditLogs',
    },
  ];

  const canAccess = (permission) => {
    if (!permission) return true;
    return hasPermission(userProfile?.role, permission);
  };

  const handleClick = () => {
    if (onNavigate) onNavigate();
  };

  const linkClasses = ({ isActive }) =>
    `group flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-colors duration-150 ${
      isActive
        ? 'bg-blue-600/50 text-white'
        : 'text-blue-200 hover:bg-blue-700/50 hover:text-white'
    }`;

  return (
    <div className="w-64 bg-blue-800 min-h-screen flex flex-col">
      <nav className="mt-4 px-3 space-y-1 flex-1">
        {navItems.map((item) =>
          canAccess(item.permission) && (
            <NavLink
              key={item.name}
              to={item.path}
              end={item.end !== undefined ? item.end : item.path === '/'}
              onClick={handleClick}
              className={linkClasses}
            >
              <span className="mr-3 flex-shrink-0">{item.icon}</span>
              {item.name}
            </NavLink>
          )
        )}

        {/* Secondary items */}
        <div className="pt-4 pb-1">
          <p className="px-3 text-xs font-semibold text-blue-400 uppercase tracking-wider">
            Tools
          </p>
        </div>
        {secondaryItems.map((item) => (
          <div key={item.name} className="relative">
            {item.comingSoon ? (
              <div className="group flex items-center px-3 py-2.5 text-sm font-medium rounded-lg text-blue-400 cursor-default">
                <span className="mr-3 flex-shrink-0">{item.icon}</span>
                {item.name}
                <span className="ml-auto text-xs bg-blue-700/50 text-blue-300 px-1.5 py-0.5 rounded">
                  Soon
                </span>
              </div>
            ) : (
              <NavLink
                to={item.path}
                onClick={handleClick}
                className={linkClasses}
              >
                <span className="mr-3 flex-shrink-0">{item.icon}</span>
                {item.name}
              </NavLink>
            )}
          </div>
        ))}

        {/* Admin section */}
        {adminItems.some((item) => canAccess(item.permission)) && (
          <>
            <div className="pt-4 pb-1">
              <p className="px-3 text-xs font-semibold text-blue-400 uppercase tracking-wider">
                Administration
              </p>
            </div>
            {adminItems.map((item) =>
              canAccess(item.permission) && (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={handleClick}
                  className={linkClasses}
                >
                  <span className="mr-3 flex-shrink-0">{item.icon}</span>
                  {item.name}
                </NavLink>
              )
            )}
          </>
        )}
      </nav>

      <div className="p-4 border-t border-blue-700/50">
        <div className="text-xs text-blue-400">
          <p className="font-semibold text-blue-300">SmileWizard</p>
          <p>HIPAA Compliant</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
